/* Layout */
import Layout from '../../views/layout/Layout.vue'

const ProductSearch = () => import(/* webpackChunkName: "product-search" */ '@/views/product/search')

const HardcodeProductMain = () => import(/* webpackChunkName: "hardcode-product-main" */ '@/views/product/hardcode/')
const HardcodeProductList = () => import(/* webpackChunkName: "hardcode-product-list" */ '@/views/product/hardcode/list')
const HardcodeProductDetail = () => import(/* webpackChunkName: "hardcode-product-detail" */ '@/views/product/hardcode/detail')
const ProductCategorize = () => import(/* webpackChunkName: "product-categorize" */ '@/views/product/categorize')

export default [
  {
    path: '/product',
    component: Layout,
    redirect: 'noredirect',
    name: 'Product',
    alwaysShow: true,
    meta: {
      title: 'product',
      icon: 'tshirt',
    },
    children: [
      {
        path: 'search',
        component: ProductSearch,
        name: 'ProductList',
        meta: {
          title: 'search',
          icon: 'search',
          accessibleName: 'product',
        },
      },

      {
        path: 'hardcode',
        component: HardcodeProductMain,
        redirect: '/product/hardcode/list',
        name: 'hardcode',
        meta: {
          title: 'hardcodeProducts',
        },
        children: [
          {
            path: 'create',
            component: HardcodeProductDetail,
            name: 'hardcode-product-create',
            meta: {
              title: 'create',
              icon: 'edit',
              accessibleName: 'hardcode',
            },
          },
          {
            path: 'edit/:id',
            component: HardcodeProductDetail,
            name: 'hardcode-product-edit',
            hidden: true,
            props: true,
            meta: {
              title: 'edit',
              icon: 'edit',
              accessibleName: 'hardcode',
            },
          },
          {
            path: 'list',
            component: HardcodeProductList,
            name: 'hardcode-product-list',
            meta: {
              title: 'list',
              icon: 'list',
              accessibleName: 'hardcode',
            },
          },
        ],
      },
    ],
  },
]
